import {
  isAudio,
  isContinueListening,
  isContinueWatching as isContinueWatchingHelper,
  isEpgLive,
  isUpcoming,
  isNew,
} from 'helpers/ContentHelper';
import { BADGE_TYPES as badge } from 'helpers/TypeHelper';

const getBadgeType = item => {
  if (isContinueListening(item)) return badge.BADGE_CONTINUE_LISTENING;
  if (isAudio(item)) return badge.BADGE_AUDIO;
  if (isEpgLive(item)) return badge.BADGE_LIVE;
  if (isUpcoming(item)) return badge.BADGE_UPCOMING;
  if (isContinueWatchingHelper(item)) return badge.BADGE_CONTINUE_WATCHING;
  if (isNew(item)) return badge.BADGE_NEW;
  return null;
};

const getBadge = item => {
  const text = getBadgeType(item);
  const type = text?.toLowerCase()?.replace(/ /g, '-');
  return { text, type };
};

export default getBadge;
